'use strict';

var loadjs = require('loadjs'),
    env,
    Rollbar,
    rollbar;

var ON_CLIENT = typeof window !== 'undefined';

if (ON_CLIENT) {
	Rollbar = require('rollbar');

	env = global.thum.config.env;
	var user = global.thum.user || null;

	rollbar = new Rollbar({
		accessToken: global.thum.env.ROLLBAR_CLIENT_ACCESS_TOKEN,
		captureUncaught: true,
		ignoredMessages: ['Script error.'],
		payload: {
			environment: env,
			user: user
		}
	});
}

// From http://youmightnotneedjquery.com/#ready
function onReady(fn) {
	if (global.document.readyState !== 'loading') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}

function checkStatus(res) {
	if (res.status >= 200 && res.status < 300) {
		return res;
	} else {
		var err = new Error(res.statusText);
		err.res = res;
		throw err;
	}
}

function loadStripeJs() {
	return new Promise(function (resolve, reject) {
		loadjs('https://checkout.stripe.com/checkout.js', {
			success: resolve,
			error: reject
		});
	});
}

function reportError(e) {
	if (env === 'dev') {
		console.error(e);
	}

	rollbar.error(e);
}

function reportAdwordsConversion(options) {
	global.goog_report_conversion(options || {});
}

function reportAdwordsPurchase(options) {
	global.gtag('event', 'conversion', {
		send_to: 'AW-869052120/qh_bCMT1g9MBENjdsp4D',
		value: options.conversionValue,
		currency: 'USD'
	});
}

module.exports = {
	checkStatus: checkStatus,
	loadStripeJs: loadStripeJs,
	onReady: onReady,
	reportError: reportError,
	reportAdwordsConversion: reportAdwordsConversion,
	reportAdwordsPurchase: reportAdwordsPurchase
};


//////////////////
// WEBPACK FOOTER
// ./client/utils.js
// module id = 10
// module chunks = 5